import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import "../../../styles/components/dialogs/items/relatedItemsExtensionGalleryComponent.scss";
import { Link } from "react-router-dom";

const RelatedItemsExtensionGalleryComponent = ({ relatedItems }) => {
  return (
    <div className="relatedItemsGallery">
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={15}
        slidesPerView={1} // Default for mobile
        // navigation
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        lazy={true}
        breakpoints={{
          640: { slidesPerView: 2 }, // Small screens
          768: { slidesPerView: 3 }, // Tablets
          1024: { slidesPerView: 4 }, // Desktops
          1280: { slidesPerView: 5 }, // Large screens
        }}
      >
        {relatedItems.map((related) => (
          <SwiperSlide key={related.relatedItemId}>
            <div className="relatedItemCard">
              <div className="imageContainer">
                <img src={related.related.pictureUrl || "https://via.placeholder.com/100"} alt={related.related.itemDescription} />
              </div>
              <p className="title">{related.related.itemDescription}</p>
              <Link className="primaryButton" to={`?d=item&itemId=${related.related.itemId}`}>פרטים נוספים</Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default RelatedItemsExtensionGalleryComponent;
